import { DefendantInfo, DefendantInfoReferralResponse } from "../../../core/models/models";
import { Default_Typeahead, ITypeaheadControl } from "../../../shared/component/typeahead/typeahead.service";
import { ReferralTypes } from "../../../shared/models/models";
import { StepItemType } from "../models/referral-page.model";

export interface CaseInfoReferralResponse {
    DefendantInfo: DefendantInfoReferralResponse;
    ReferralInfo: ReferralInfoModel;
    TabsMeta: TabsMetaModel[];
    CaseTypeId: number;
    IsCivilCase: boolean;
}

export interface ReferralInfoDetails {
    DefendantInfo: DefendantInfo;
    ReferralInfo: ReferralInfoModel;
    TabsMeta: ReferralInfoTabsMetaModel[];
    CaseTypeId: number;
    IsCivilCase: boolean;
}

export interface ReferralInfoModel {
    ReferralDate: string;
    ReportReceivedDate: string;
    ReportNumber: string;
    Dsn: string;
    DsnDescription: string;
    DsnSequence: string;
    Ocn: string;
    CaseCategory: string;
    CaseCategoryDescription: string;
    ArrestTime: string;
    ArrestDate: string;
    ArrestNumber: string;
    BookingPD: string;
    BookingPDDescription: string;
    NeighborhoodCode: string;
    NeighborhoodCodeDescription: string;
    HourHold: boolean;
    Juvenile: boolean;
    SequenceNumber: string;
    PDNumber: string;
    PDNumberDescription: string;
    LabNumber: string;
    NoteType: string;
    Notes: string;
    HeaderName: string;
    CivilClient: string;
    CivilClientDescription: string;
    CivilMatter: string;
    CivilDescription: string;
}

export interface TabsMetaModel {
    Identifier: string;
    Name: string;
    HasData: boolean;
}

export interface ReferralInfoTabsMetaModel {
    Type: StepItemType;
    Name: string;
    HasData: boolean;
}

export const Default_DefendatInfo: DefendantInfo = {
    intAddressFlag: false,
    entityFlag: false,
    witnessType: '',
    lastName: '',
    firstName: '',
    middleName: '',
    dateOfBirth: '',
    address1: '',
    address2: '',
    city: '',
    state: '',
    zipCode: '',
    phone: '',
    employer: '',
    contact: '',
    race: '',
    sex: '',
    height: '',
    weight: '',
    hairColor: '',
    eyeColor: '',
    nationality: '',
    email: '',
    placeOfBirth: '',
    dlState: '',
    dlNumber: '',
    dLClassification: '',
    dLExpirationDate: '',
    ssn: '',
    sid: '',
    fbiIdentifier: '',
    inmateNumber: '',
    lid: '',
    defendantStatus: '',

}

export interface DefendantInfoFormValue {
    intAddressFlag: boolean;
    entityFlag: boolean;
    witnessType: ITypeaheadControl;
    lastName: string;
    firstName: string;
    middleName: string;
    dateOfBirth: string;
    address1: string;
    address2: string;
    city: string;
    state: string;
    zipCode: string;
    phone: string;
    employer: string;
    contact: string;
    race: ITypeaheadControl;
    sex: ITypeaheadControl;
    height: string;
    weight: string;
    hairColor: ITypeaheadControl;
    eyeColor: ITypeaheadControl;
    nationality: ITypeaheadControl;
    email: string;
    placeOfBirth: ITypeaheadControl;
    dlState: string;
    dlNumber: string;
    dLClassification: ITypeaheadControl;
    dLExpirationDate: string;
    ssn: string;
    sid: string;
    fbiIdentifier: string;
    inmateNumber: string;
    lid: string;
    defendantStatus: ITypeaheadControl;
}

export interface ReferralInfoFormValue {
    ArrestDate: string;
    ArrestNumber: string;
    BookingPD: ITypeaheadControl;
    NeighborhoodCode: ITypeaheadControl;
    HourHold: boolean;
    ReportNumber: string;
    ReferralDate: string;
    Dsn: ITypeaheadControl;
    DsnSequence: string;
    PDNumber: ITypeaheadControl;
    LabNumber: string;
    CaseCategory: ITypeaheadControl;
    Juvenile: boolean;
    Ocn: string;
}

export const Default_DefendatInfoFormValues: DefendantInfoFormValue = {
    intAddressFlag: false,
    entityFlag: false,
    witnessType: Default_Typeahead,
    lastName: "",
    firstName: "",
    middleName: "",
    dateOfBirth: "",
    address1: "",
    address2: "",
    city: "",
    state: "",
    zipCode: "",
    phone: "",
    employer: "",
    contact: "",
    race: Default_Typeahead,
    sex: Default_Typeahead,
    height: "",
    weight: "",
    hairColor: Default_Typeahead,
    eyeColor: Default_Typeahead,
    nationality: Default_Typeahead,
    email: "",
    placeOfBirth: Default_Typeahead,
    dlState: "",
    dlNumber: "",
    dLClassification: Default_Typeahead,
    dLExpirationDate: "",
    ssn: "",
    sid: "",
    fbiIdentifier: "",
    inmateNumber: "",
    lid: "",
    defendantStatus: Default_Typeahead
}

export interface QuickUpdateDefendant_Request {
    DefendantInfo: QuickUpdate_DefendnatDetail;
    SequenceNumber: number;
}

export interface QuickUpdate_ReferralDetail {
    ReportNumber: string;
    ReferralDate: string;
    Dsn: string;
    DsnSequence: string;
    Ocn: string;
    CaseCategory: string;
    ArrestTime: string;
    ArrestDate: string;
    ArrestNumber: string;
    BookingPD: string;
    NeighborhoodCode: string;
    HourHold: boolean;
    PDNumber: string;
    LabNumber: string;
    Juvenile: boolean;
    CivilClient: string;
    CivilMatter: string;
    CivilDescription: string;
}

export interface QuickUpdate_DefendnatDetail {
    DefendantNumber: number;
    Ssn: string;
    IsEntity: boolean;
    FirstName: string;
    Agency: string;
    MiddleName: string;
    LastName: string;
    Phone: string;
    Address1: string;
    Address2: string;
    City: string;
    State: string;
    ZipCode: string;
    Race: string;
    Sex: string;
    Height: string;
    Weight: string;
    PlaceOfBirth: string;
    LocalId: string;
    StateId: string;
    FederalId: string;
    DateOfBirth: string;
    Hair: string;
    Eyes: string;
    LicenseState: string;
    LicenseNumber: string;
    LicenseClass: string;
    LicenseExpirationDate: string;
    InmateNumber: string;
    DefendantStatus: string;
    Nationality: string;
    IsIntl: boolean;
    Email: string;
}

export interface ReferralInfoTabsMeta {
    IsDefendantTabComplete: boolean;
    IsChargeTabComplete: boolean;
    IsWitnessTabComplete: boolean;
    IsDocumentTabComplete: boolean;
    IsCoDefendantTabComplete: boolean;
    IsCivilReferralTabComplete: boolean;
    IsList: ReferralTypes;
}

export interface ChargeGroupDto {
    date: string;
    location: string;
    city: string;
    state: string;
    zip: string;
    charges: ChargeDto[];
}

export const Default_chargeDetails: ChargeGroupDto[] = [{
    date: '',
    location: '',
    city: '',
    state: '',
    zip: '',
    charges: [{
        charge: '',
        chargeCode: '',
        chargeLang: '',
        enhancements: [],
        modifiers: []
    }]
}];

export interface ChargeDto {
    charge: string;
    chargeCode: string;
    chargeLang: string;
    modifiers: string[];
    enhancements: string[];
}

export interface CaseSearchEntry {
    caseId: string;
    defendantNumber: number;
    jurisdiction: string;
    causeNumber: string;
    fileNumber: string;
    fileNumberTooltip: string;
    reportNumber: string;
    reportNumberTooltip: string;
    charge: string;
    chargeTooltip: string;
    caseType: string;
    issuedDate: string;
    status: string;
    stage: string;
    finalDispDate: string;
    isAuthorized?: boolean;
}

export interface ReferrealCharges {
    OffenseFromDate: string;
    ChargeDescriptionDisplayString: string;
    TicketNumber: string;
    OffenseStreetAddress1: string;
    OffenseCity: string;
    CountNumber: string;
    hdnOffenseFromDate: string;
    OffenseToDate: string;
    ReferralChargeDescription: string;
    ChargeCode: string;
    Statute: string;
    ChargeModifier: string;
    ChargeDescription: string;
    OffenseState: string;
    OffenseZipCode: string;
    ChargeTypeClass: string;
    ItemNumber: string;
    IsEdit: boolean;
    ChargeNcic: string;
}

export interface ReferralCodefendantChargesToSave {
    sequenceNumbers: string;
    chargeIds: string;
    allCoDefendantsAreReferred: boolean;
}

export interface ReferralReviewDetail {
    Defendant: ReferralReviewDefendant;
    Charges: Array<ReferralReviewCharge>;
    Witnesses: Array<ReferralReviewWitness>;
    Documents: Array<ReferralReviewDocument>;
    CoDefendants: Array<ReferralReviewCodefendant>;
}

export interface ReferralReviewDefendant {
    Name: string;
    Address: string;
    Address2: string;
    City: string;
    State: string;
    ZipCode: string;
    SSN: string;
    DOB: string;
    HomePhone: string;
    Race: string;
    Sex: string;
    LicenseNumber: string;
    MugshotImageURL: string;
    DefendantNumber: number;
}

export interface ReferralReviewCharge {
    ChargeCount: number;
    ChargeCode: string;
    Statute: string;
    Sevirity: string;
    Description: string;
    OffFromDate: string;
    ChargeModifier: string;
    EnhancementCode: string;
}

export interface ReferralReviewWitness {
    Name: string;
    Type: string;
    Address: string;
    Address2: string;
    City: string;
    State: string;
    ZipCode: string;
    Phone: string;
    Dob: string;
    Race: string;
    Sex: string;
    SSN: string;
    DlNumber: string;
    Department: string;
    MugshotImageURL: string;
}

export interface ReferralReviewCodefendant {
    Name: string;
    Address: string;
    Address2: string;
    City: string;
    State: string;
    ZipCode: string;
    SSN: string;
    DOB: string;
    HomePhone: string;
    Race: string;
    Sex: string;
    LicenseNumber: string;
    SequenceNumber: number;
    ReportNumber: string;
    DefendantNumber: string;
    CommonCountNumber: string;
    ActualCountNumber: string;
    MugshotImageURL: string;
}

export interface ReferralReviewDocument {
    FileName: string;
    DocumentType: string;
    FileExt: string;
    Comments: string;
}


export interface SaveReferralInfoRequestPayload {
    referralDetail: QuickUpdate_ReferralDetail;
    SequenceNumber: number;
    tab: StepItemType | null;
}

export interface SubmitReferralDetailsRequestPayload {
    referralDetail: QuickUpdate_ReferralDetail;
    sequenceNumber: string;
}